export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`, `5XL`],
  [`Российский размер`, `42`, `44`, `46`, `48`, `50`, `52`, `54`, `56`, `58`],
  [`Рост`, `164`, `170`, `170`, `170`, `170`, `170`, `170`, `170`, `170`],
  [`Объем груди(a)`, `84`, `88`, `92`, `96`, `100`, `104`, `108`, `112`, `116`],
  [
    `Обхват бёдер (b)`,
    `90`,
    `94`,
    `98`,
    `102`,
    `106`,
    `110`,
    `114`,
    `118`,
    `122`
  ],
  [
    `Ширина изделия по груди (c)`,
    `38`,
    `40`,
    `42`,
    `43`,
    `45`,
    `48`,
    `52`,
    `57`,
    `58`
  ],
  [`Длина изделия (d)`, `62`, `63`, `64`, `65`, `68`, `69`, `70`, `72`, `80`]
];
